if (!customElements.get('cart-size-selector')) {
  class CartSizeSelector extends HTMLElement {
    connectedCallback() {
      if (this.isBound) return;
      this.isBound = true;
      this.select = this.querySelector('select');
      if (!this.select) return;

      this.select.addEventListener('change', (event) => {
        // Impede que o cart-drawer-items trate a troca como alteracao de quantidade
        event.stopPropagation();
        this.swapVariant();
      });
    }

    get root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    get requestHeaders() {
      return { 'Content-Type': 'application/json', Accept: 'application/json' };
    }

    async swapVariant() {
      const newVariantId = parseInt(this.select.value, 10);
      const currentVariantId = parseInt(this.dataset.variantId, 10);
      if (!newVariantId || newVariantId === currentVariantId) return;

      this.setLoading(true);
      this.showError('');

      try {
        const cart = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const item = cart.items.find((lineItem) => lineItem.key === this.dataset.key);
        if (!item) throw new Error((window.cartStrings && window.cartStrings.error) || 'Não foi possível trocar o tamanho.');

        const newItem = { id: newVariantId, quantity: item.quantity };
        if (item.properties && Object.keys(item.properties).length) newItem.properties = item.properties;
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
          newItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
        }

        const addResponse = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: this.requestHeaders,
          body: JSON.stringify({ items: [newItem] }),
        });
        const addData = await addResponse.json();
        if (!addResponse.ok) {
          throw new Error(addData.description || addData.message || 'Tamanho indisponível no momento.');
        }

        const isDrawer = this.dataset.context === 'drawer';
        const changeResponse = await fetch(`${this.root}cart/change.js`, {
          method: 'POST',
          headers: this.requestHeaders,
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: isDrawer ? ['cart-drawer', 'cart-icon-bubble'] : [],
            sections_url: window.location.pathname,
          }),
        });
        const state = await changeResponse.json();
        if (!changeResponse.ok) {
          throw new Error(state.description || state.message || 'Não foi possível trocar o tamanho.');
        }

        this.render(state, isDrawer);
      } catch (error) {
        this.select.value = String(currentVariantId);
        this.showError(error.message);
        this.setLoading(false);
      }
    }

    render(state, isDrawer) {
      if (!isDrawer || !state.sections || !state.sections['cart-drawer']) {
        window.location.reload();
        return;
      }

      const parse = (html, selector) =>
        html ? new DOMParser().parseFromString(html, 'text/html').querySelector(selector) : null;

      const drawer = document.querySelector('cart-drawer');
      const currentInner = document.querySelector('#CartDrawer .drawer__inner');
      const newInner = parse(state.sections['cart-drawer'], '.drawer__inner');
      if (currentInner && newInner) currentInner.innerHTML = newInner.innerHTML;

      const bubble = document.getElementById('cart-icon-bubble');
      const newBubble = parse(state.sections['cart-icon-bubble'], '.shopify-section');
      if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;

      if (drawer) {
        drawer.classList.toggle('is-empty', state.item_count === 0);
        if (typeof drawer.setupClearCartButton === 'function') drawer.setupClearCartButton();
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
      }
    }

    setLoading(isLoading) {
      this.classList.toggle('is-loading', isLoading);
      this.select.disabled = isLoading;
      const row = this.closest('.cart-item');
      if (row) {
        row.querySelectorAll('.loading__spinner').forEach((spinner) => spinner.classList.toggle('hidden', !isLoading));
      }
    }

    showError(message) {
      const row = this.closest('.cart-item');
      const errorText = row ? row.querySelector('.cart-item__error-text') : null;
      if (errorText) errorText.textContent = message;
    }
  }

  customElements.define('cart-size-selector', CartSizeSelector);
}
